import React from 'react';
import {
  Flex,
  Box,
  Body,
  List,
  ListItem,
  Card,
} from '@edreamsodigeo/prisma-design-system';
import PropTypes from 'prop-types';

export const BenefitsCard = ({ benefits, title }) => {
  return (
    <Card>
      <Flex gap="base" flexDirection="column">
        <Body weight="normal" type="small">
          {title}
        </Body>
        <List size="small" spacing="1x_small">
          {benefits.map((benefit) => (
            <ListItem key={benefit.id} marker="included">
              <Box pl="1x_small">
                <Body type="small">{benefit.content}</Body>
              </Box>
            </ListItem>
          ))}
        </List>
      </Flex>
    </Card>
  );
};

BenefitsCard.propTypes = {
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.node,
        PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
            PropTypes.node,
          ])
        ),
      ]).isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
};
